import { Group, Loader, Text } from '@mantine/core';

/** One way of saying "wait a moment", so waiting looks the same everywhere. */
export function Loading({ label = 'Loading' }: { label?: string }) {
  return (
    <Group gap="xs" my="md" role="status">
      <Loader size="xs" type="dots" />
      <Text c="dimmed" size="sm">
        {label}...
      </Text>
    </Group>
  );
}
